import apiClient from './config.js';

export default {
  async getGeojsonFromShapefile(file, layer_name, token) {
    const formData = new FormData();
    formData.append('zip_file', file);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`geos/shp_to_geojson?layer_name=${layer_name}`, formData);
  },
  async inspectKmzFile(file, token) {
    const formData = new FormData();
    formData.append('kmz_file', file);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`geos/inspect_kmz`, formData);
  },
  async getGeojsonFromKmz(file, layer_name, token) {
    const formData = new FormData();
    formData.append('kmz_file', file);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`geos/kmz_to_geojson?layer_name=${layer_name}`, formData);
  },
  async inspectGpxFile(file, token) {
    const formData = new FormData();
    formData.append('gpx_file', file);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`geos/inspect_gpx`, formData);
  },
  async getGeojsonFromGpx(file, layer_name, token) {
    const formData = new FormData();
    formData.append('gpx_file', file);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return await apiClient.post(`geos/gpx_to_geojson?layer_name=${layer_name}`, formData);
  },
};